import { getConfig } from '../firebase';
import { useReducer } from 'react';
import useEvent from './useEvent';

let config = {};

function parseValue(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

function useRemoteConfig(key, { cache = true } = {}) {
  const [, forceRender] = useReducer(s => s + 1, 0);
  useEvent('remoteConfigActivated', forceRender);

  if (cache && config[key]) return config[key];

  const fbConfig = getConfig();
  const { _value } = fbConfig.getValue(key);
  const parsed = parseValue(_value);

  if (cache) {
    config[key] = parsed;
  }

  return parsed;
}

export default useRemoteConfig;
